import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { FormBuilder, Validators } from '@angular/forms';
import html2canvas from 'html2canvas';
import { ToastService } from '@projects/shared/src/app/services/toast/toast.service';
import { ThisReceiver } from '@angular/compiler';
import { NavService } from '@projects/shared/src/app/services/nav.service';
import { Observable, Subscriber } from 'rxjs';
import { LoaderService } from '@app/core/loader.service';
import { VideoRecordingService } from './video-recording.service';
@Injectable({
  providedIn: 'root',
})
export class BugReportService {
  bugReportForm = this.fb.group({
    bugType: ['', Validators.required],
    subject: ['', Validators.required],
    description: ['', Validators.required],
  });
  bugsType = [
    { name: 'High', code: 'high', inactive: false },
    { name: 'Moderate', code: 'moderate', inactive: false },
    { name: 'Low', code: 'low', inactive: false },
  ];
  campaignId: string;
  title = 'imgtobase64';
  externalSelectedImages: Array<any> = [];

  constructor(
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private authService: AuthenticationService,
    private toastService: ToastService,
    private navService: NavService,
    private loaderService: LoaderService,
    private videoRecordingService: VideoRecordingService
  ) {
    this.campaignId = this.authService.getDefaultCampaign()!.Id;
  }

  async postBug() {
    this.externalSelectedImages = this.externalSelectedImages.map((d) => d.base64);
    const url = `/bugReport`;
    this.navService.toggleBugReportPane();
    const video = await this.videoRecordingService.recordPageScroll();

    let user = this.authService.authData;
    let { bugType, subject, description } = this.bugReportForm.value;
    this.loaderService.toggleMainLoader(true);
    
    const formData = new FormData();

    formData.append('Title', subject?.toString() || '');
    formData.append('Description', description?.toString() || '');
    formData.append('Priority', bugType?.toString() || '');
    formData.append('CampaignId', this.campaignId);
    formData.append('ClientId', user?.ClientId);
    formData.append('UserDetail', user?.Email);
    formData.append('CreatedBy', user?.Id);
    formData.append('Screenshot', video, 'screen-recording.webm');

    this.httpClient
      .post(
        url,
        formData,
        {
          observe: 'response',
        }
      )
      .subscribe((res) => {
        this.loaderService.toggleMainLoader(false);
        if (res.status === 200) {
          this.toastService.success('Bug reported Successfully');
        } else {
          this.toastService.error('Something went wrong. try again');
          this.navService.toggleBugReportPane();
        }
        this.clearForm();
      });
  }

  // Check Field from same group form
  checkFieldValidation(fieldName: string) {
    return (
      this.bugReportForm.get(fieldName)?.invalid &&
      (this.bugReportForm.get(fieldName)?.dirty || this.bugReportForm.get(fieldName)?.touched)
    );
  }

  //image convert to base64
  convertToBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.externalSelectedImages.push({ Title: file.name, base64: d.split(',')[1] });
    });
  }

  readFile(file: File, subscriber: Subscriber<any>) {
    const filereader = new FileReader();
    filereader.readAsDataURL(file);

    filereader.onload = () => {
      subscriber.next(filereader.result);
      subscriber.complete();
    };
    filereader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  checkMaxFileSelections() {
    return !(this.externalSelectedImages.length >= 2);
  }
  clearForm() {
    this.externalSelectedImages = [];
    this.bugReportForm.reset();
  }
  removeExternalImage(index: number) {
    this.externalSelectedImages.splice(index, 1);
  }
}
